// Customer reads used outside the customer page. docs/features/peek.md.

import { apiFetchAuthed } from '../apiHelpers';
import type { CustomerOrders } from './types';

/** The customer page's orders table and totals, the same numbers the page shows. */
export const getCustomerOrders = (id: number): Promise<CustomerOrders> =>
  apiFetchAuthed(`/customers/${id}/orders`, { silent: true });
